export { default } from './SpotThumbnail';
